import { render, staticRenderFns } from "./ArticleLoadingContainer.vue?vue&type=template&id=23c7e768&"
import script from "./ArticleLoadingContainer.vue?vue&type=script&lang=js&"
export * from "./ArticleLoadingContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports